function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#LINK_svg__clip0_1_66)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#2A5ADA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 6.25l-1.587.923-4.326 2.529-1.587.923v8.75l1.587.923 4.365 2.529 1.588.923 1.587-.923 4.286-2.529 1.587-.923v-8.75l-1.587-.923-4.326-2.529L15 6.25zm-4.325 11.279V12.47L15 9.943l4.325 2.528v5.058L15 20.057l-4.325-2.528z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "LINK_svg__clip0_1_66"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "08ddac01a4c2666c4ed8160116bb03ab.svg";
export { SvgLink as ReactComponent };